<template>
  <!-- 商家续费 -->
  <div class='saas-mch-pay-fee bgc-f5f'>
    <!-- 图表 -->
    <div class="x-w100p bgc-f x-bd-ra-3  x-m-b-10">

      <div class="">
        <el-col>
          <div ref="chart" id="mcfwss" style="height:260px;"></div>
        </el-col>
      </div>
    </div>
    <!-- 表 -->
    <div class="x-w100p bgc-f x-bd-ra-3 x-flex-1" style=" overflow: hidden; position: relative;">
      <!-- <div class="x-w100p x-p-10-15 x-d-flex x-bd-bottom">
        <div class="x-h36 x-m-r-10 x-w120">
          <el-select class="x-w100p" v-model="PayType" placeholder="请选择">
            <el-option v-for="item in Sjtype" :key="item.value" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="x-h36 x-m-r-10">
          <timeChang @getTimeData="getTimeData"></timeChang>
        </div>
        <div class="x-h36 x-m-r-10 x-w270">
          <el-input placeholder="商户,手机号,商户名" v-model="SearchStr">
            <el-button slot="append" icon="el-icon-search" @click="fwssDataPro()"><span class="c-0" >查询</span>
            </el-button>
          </el-input>
        </div>
        <div class="x-h36 x-lh-36 x-m-r-10">
          <el-checkbox v-model="mhButton">模糊</el-checkbox>
        </div>
      </div> -->
      <div class="x-w100p x-flex-1 x-h100p">
        <vxe-table stripe ref="xTable2" height="100%" border="inner" align="center"
          :row-config="{isCurrent: true, isHover: true}" :data="MchData">
          <vxe-column field="RC" title="序" fixed="left" width="60"></vxe-column>
          <vxe-column v-for="(item,index) in MchDaaHead" :key="index"  :field="item.field"
            :title="item.title" :min-width="item.width">
            <template slot-scope="scope">
              <div class="x-flex x-row-center">
                <div class="wen" v-if="item.title =='机构名称' || item.title =='备注'">
                  {{scope.row[item.field]}}
                </div>
                <div class="c-danger" v-else-if="item.title=='结算金额'">
                  {{Number(scope.row[item.field]).toFixed(2)}}
                </div>
                <div v-else>{{scope.row[item.field]}}</div>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>

    </div>
    <div style="position: absolute; bottom: 10px;  z-index: 999 ;width: calc(100% - 40px);"
      class="x-flex x-row-between ">
      <!-- 合计 -->
      <div v-if="totalList.length > 0" class="x-flex-1 x-flex x-m-r-20" style="overflow: auto;">
        <div class="x-m-r-10" style="white-space: nowrap;">合计：{{total.toFixed(2)}}</div>
        <div class="x-m-r-10 x-flex " style="white-space: nowrap;" v-for="(item,index) in totalList" :key="index">
          {{item.pay_desc}} {{Number(item.sh_sk_money).toFixed(2)}}
          <div v-if="index < totalList.length -1">,</div>
        </div>
      </div>
      <div v-show="this.pay_detail.length == 0"></div>
      <div class="x-row-right x-flex">
        共 {{ TR }} 条
        <el-pagination background layout="sizes,prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
        :pager-count='5'
          :page-sizes="[50, 100, 200, 300, 400, 500,  1000]" :page-size="pageSize" @size-change="fSizeChange"
          :current-page="nowPage">
        </el-pagination>
        <img class="x-cur-poi x-p-b-2 x-m-t-5 x-wh30" src="@/assets/img/dc.png" @click="fExportDataEvent()">
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    components: {},
    props: {
      actTabs: {
        type: [String],
        default: '',
      },
      SearchStr: {
        type: [String],
        default: "",
      },
      PayType: {
        type: [String],
        default: "",
      },
      partner_phone: {
        type: [String],
        default: '',
      },
      dataTime: [Array, Object],
      default: () => {
        return []
      },
    },
    data() {
      return {
        //
        fwssData: [],
        // 类型
        // PayType: "全部",
        // Sjtype: [{
        //     value: "全部",
        //   },
        //   {
        //     value: "软件续费",
        //   },
        //   {
        //     value: "短信充值",
        //   }
        // ],
        // 时间
        //查询
        // 模糊
        mhButton: true,
        // 数据
        MchData: [],
        MchDaaHead: [{
          field: "pay_desc",
          title: "付费类型",
          width: "100px",
        }, {
          field: "sh_sk_money",
          title: "付费金额",
          width: "100px",
        }, {
          field: "pay_time",
          title: "付费时间",
          width: "160px",
        }, {
          field: "user_memo",
          title: "备注信息",
          width: "240px",
        }, {
          field: "sh_phone",
          title: "商户手机",
          width: "120px",
        }, {
          field: "sh_name",
          title: "商户名称",
          width: "180px",
        }, {
          field: "soft_bb",
          title: "软件版本",
          width: "100px",
        }, {
          field: "sh_type",
          title: "商户类型",
          width: "100px",
        }, {
          field: "partner_phone",
          title: "合作伙伴手机",
          width: "120px",
        }, {
          field: "partner_comp_name",
          title: "合作伙伴名",
          width: "160px",
        }],
        // 底 【页】
        pager: {
          paye: 1,
          patiao: 0,
        },
        TR: 0,
        TP: 0,
        nowPage: 1,
        pageSize: 50,
        totalList: [],
        // 合计
        total: 0.00,
        pay_detail: [],
      };
    },
    computed: {},
    watch: {
      // actTabs(val) {
      //   console.log(val,'actTabs')
      //   if (val == '商户付费') {
      //     this.nowPage = 1;
      //     this.fwssDataPro()
      //   }
      // },
      // dataTime(val) {
      //   console.log(val)
      //   this.nowPage = 1;
      //   this.fwssDataPro('', val[0], val[1])
      // },
      // partner_phone(val) {
      //   this.fwssDataPro()
      // },
      PayType(item) {
        this.PayType = item;

        this.nowPage = 1;
        this.fwssDataPro();
      },
    },
    methods: {
      fExportDataEvent() {
        this.$refs.xTable2.exportData({
          type: 'csv'
        })
      },
      // 表格数据
      async fwssDataPro(type) {
        console.log(type)
        if (type == 'init') {
          this.nowPage = 1;
        }
        let res = await this.fGetBykSkDetail()
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }

        // 表数据
        this.MchData = res.data;
        // 图表数据
        this.fwssData = res.day_total;
        // 合计
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = Number(res.data[0].TR);
          this.TP = Number(res.data[0].TP);
        }
        console.log(this.totalList)
        if (res.total) {
          this.totalList = res.total;
          this.total = 0
          this.totalList.forEach(item => {
            this.total += Number(item.sh_sk_money)
          })
        }
        //图表
        this.$nextTick(function() {
          // 【】
          this.fwssEchart();
        })
      },
      // 图表数据  【】
      fwssEchart() {
        // 以下全局，引入echarts属性（若是多个页面需要引入echarts的话，一定要在main.js中引入
        var myaChart = echarts.init(document.getElementById('mcfwss'));
        // 响应式图表(通用)
        window.addEventListener('resize', () => {
          myaChart.resize();
        })
        //名字
        let rt = []
        for (let i = 0; this.fwssData.length > i; i++) {
          rt.push(this.fwssData[i].pay_time)
        }
        // 数据
        let xiao = []
        for (let i = 0; this.fwssData.length > i; i++) {
          xiao.push(this.fwssData[i].sh_sk_money)
        }
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
          },
          // 头部按钮 详细信息
          legend: {
            top: '5%',
            left: 'center'
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: rt //名称
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "40px",
            bottom: "40px"
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, '100%']
          },
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 80
          }, ],
          series: [{
            name: '付费金额',
            type: 'line',
            // smooth: true,           //点线直连==更改为【点线弧连】
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'RGB(255,70,70)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'RGB(255,168,168)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 255, 255)'
                }
              ])
            },
            data: xiao //数据
          }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myaChart.setOption(option);
      },
      // 接受子组件传递的时间
      getTimeData(time) {
        this.dataTime[0] = time[0];
        this.dataTime[1] = time[1];

        this.nowPage = 1;
        this.fwssDataPro();
      },
      // 点击翻一页
      fCurrentChange(e) {
        this.nowPage = e;
        this.fwssDataPro();
      },
      fSizeChange(e) {
        this.pageSize = e;
        this.nowPage = 1;
        this.fwssDataPro();
      },
      // ---------------------- 请求函数 开始 ------------------------
      // 商家续费 GET_SMSAAS_MCH_PAY_DETAIL
      async fGetBykSkDetail() {
        let js = {};
        js['PARTNER_PHONE'] = this.partner_phone;
        js['PAY_TYPE'] = this.PayType; //类型
        js['START_TIME'] = this.dataTime[0];
        js['OVER_TIME'] = this.dataTime[1];
        js['SEARCH_STR'] = this.SearchStr;
        js['MH_YN'] = this.mhButton ? 'Y' : 'N';
        js['PAGE_SIZE'] = this.pageSize;
        js['NOW_PAGE'] = this.nowPage;
        js['SRV_TYPE'] = "MAIN_SRV"; //MAIN_SRV【主服务器】  SUB_SRV【子服务器】
        js['ORDER_BY'] = "";
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmUnionPlatformQueryApi("GET_SMSAAS_MCH_PAY_DETAIL", js, 'SAAS');
        console.log(res);
        return res;
      },
    },
    beforeCreate() {},
    async created() {
      // 默认获取本月时间
      // this.dataTime = [this.bykApi.timeHelper.fGetQhDay(0) + ' 00:00:01', this.bykApi.timeHelper.fGetNowTime(1) +
      //   ' 23:59:59'
      // ];
      // 默认获取数据
      // this.fwssDataPro();
    },
    beforeMount() {},
    mounted() {

    }
  }
</script>
<style lang="less" scoped>
  .saas-mch-pay-fee {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // .gaoH {
    //   height: calc(100% - 123px);
    // }

  }
</style>



// WEBPACK FOOTER //
// src/view/saasMchPayFee.vue